import { useEffect, useState } from "react";
import Table, { Column } from "../../common/table";
import { useNavigate } from "react-router-dom";
import { Site } from "../../../types/Site";
import SiteService from "../../../services/site.service";
import { useTranslation } from "react-i18next";

export default function SitesTable() {
    const { t } = useTranslation();

    const columns: Column<Site>[] = [
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="hide-on-mobile bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('sites.address')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI} className="hide-on-mobile whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500">
                    {row.address.address1}
                </td>
            ),
        },
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('sites.city')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI} className="whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500">
                    {row.address.locality}
                </td>
            ),
        },
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="hide-on-mobile bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('sites.state')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI} className="whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500">
                    {row.address.region}
                </td>
            ),
        },
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('sites.country')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI} className="whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500">
                    {row.address.country}
                </td>
            ),
        },
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('sites.zip')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI} className="whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500">
                    {row.address.postalCode}
                </td>
            ),
        }
    ];

    const [rows, setRows] = useState<Site[]>([]);
    const navigate = useNavigate();

    const handleRowClick = (siteId: string) => {
        navigate(`/sites/${siteId}`);
    };

    const fetchData = async () => {
        const response = await SiteService.getSites();
        const data = await response.json();
        setRows(data);
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Table
            columns={columns}
            rows={rows}
            title={t('map.sites')}
            currentPage={1}
            pageSize={1}
            totalRows={1}
            onRowClick={row => handleRowClick(row._id)}
        />
    );
}
